module.exports = __webpack_public_path__ + "media/packs/images/flags/HR-1c5a8ceaa9d8f01b2409b4e031aec5c3.svg";